/* eslint-disable global-require */

export default {
  ...require('./baseActions').default,
  ...require('./bots').default,
};
